var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice flex flex-row"},[_c('div',{staticClass:"notice-title"},[_vm._v("联盟公告")]),_c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(item.noticeTitle)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }